import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import authReducer from './auth/authSlice'
import feedbackReducer from './feedback/feedbackSlice'
import rsaReducer from './selfService/selfServiceSlice'
import referralReducer from './referral/referralSlice'
import statementReducer from './statement/statementSlice'
import transactionReducer from './transactions/transactionSlice'
import utilsReducer from './utils/utilsSlice'

export const store = configureStore({
    reducer: {
        auth: authReducer,
        feedback: feedbackReducer,
        referral: referralReducer,
        selfService: rsaReducer,
        statement: statementReducer,
        transactions: transactionReducer,
        utils: utilsReducer
    },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
    >;